import { Typography } from '@mui/material';
import StockList from './StockList';

export default function StockManagement() {


    return (
        <>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                Stock Management
            </Typography>
            <StockList />
        </>

    )
}
